// react
import React from 'react';
// style
import './style/plan.css'
// spliter
import { splitNumber } from '../../../features/splitNumber/splitNumber.tsx';
// cookie
import Cookies from "js-cookie";
// toast
import { toast } from 'react-toastify';
import { toastOptions } from '../../../features/toast/toast.tsx';

const Plans = (props: any) => {
    let image: any;
    let status = 'btn-bronze';
    let status_btn = 'btn-outline-bronze';
    let class_name = 'bronze-card'
    if (props.item.title === 'برنز') {
        image = require('./../../../assets/media/icon/12.png')
        status = 'btn-bronze';
        status_btn = 'btn-outline-bronze';
        class_name = 'bronze-card'
    } else if (props.item.title === 'نقره ای') {
        image = require('./../../../assets/media/icon/13.png');
        status = 'btn-silver';
        status_btn = 'btn-outline-silver'
        class_name = 'silver-card'
    } else if (props.item.title === 'طلایی') {
        image = require('./../../../assets/media/icon/14.png');
        status = 'btn-gold';
        status_btn = 'btn-outline-gold'
        class_name = 'gold-card'
    } else {
        image = require('./../../../assets/media/icon/15.png')
        status = 'btn-diamond';
        status_btn = 'btn-outline-diamond'
        class_name = 'diamond-card'
    }
    const sendOrder = (id) => {
        if (Cookies.get('agent_token')) {
            localStorage.setItem('order_id', id);
            window.open('/agent/panel/orders/create', '_self')
        }
        else {
            toast.error('ابتدا وارد اکانت خود شوید', toastOptions)
        }
    }
    return (
        <>
            <div className={`card ${class_name} card-body border-0 shadow`}>
                <div className={'d-flex align-items-center'}>
                    <img className={'plan-img'} alt={'bronze'}
                        src={image} />
                    <h6 className={'fw-bold card-title ms-3'}>
                        {props.item.title}
                    </h6>
                </div>
                <div className={'text px-2 mt-2'}>
                    <p className={'card-text font-medium line-30'}>
                        {props.item.description ? props.item.description : 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنا'}
                    </p>
                </div>
                <div className={'d-flex mb-1 mt-2'}>
                    <button
                        onClick={() => sendOrder(props.item.id)}
                        className={`btn ${status} font-medium w-75`}>
                        ثبت سفارش
                    </button>
                    <button className={`btn ${status_btn} ms-2 font-medium w-50`}>
                        <span className='me-1'>
                            {splitNumber(props.item.price)}
                        </span>
                        تومان
                    </button>
                </div>
            </div>
        </>
    )
}

export default Plans;